import React from "react";
import ReactDOM from  "react-dom";
import MetypeHome from './metype_home';
import { hostToOrigin } from '../../util/pure_functions/utils';
import { checkIfLoggedIn } from "../../util/login";

export default function init(target) {
  global.metypeHost =  hostToOrigin(target.getAttribute("data-metype-host"));
  global.metypeFeatureToggles = JSON.parse(target.getAttribute("data-feature-toggles"));
  const freeTrialPeriod = target.getAttribute("data-trial-period");

  const contact_details = { 'contact_number': target.getAttribute("data-contact-number"),
                            'email_address': target.getAttribute("data-email-address")};
  const social_links = {'facebook_link': target.getAttribute('data-facebook-link'),
                        'google_link': target.getAttribute('data-google-link'),
                        'twitter_link': target.getAttribute('data-twitter-link')};
  checkIfLoggedIn();

  ReactDOM.render(React.createElement(MetypeHome, {
    trialPeriod: freeTrialPeriod,
    contact_details: contact_details,
    social_links: social_links
  }), target);
}



// WEBPACK FOOTER //
// ./app/javascript/pages/metype_home/init.js